import axios from 'axios';
import {useContext, useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { Context } from '../../context/Context';
import MainNav from '../Navbar/MainNav';
import '../../assets/css/PostDetails.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../footer/Footer';
import { Delete, Edit, Save } from '@material-ui/icons';
import { Button } from 'react-bootstrap';
import LoadingSpinner from '../spinner/LoadingSpinner';
import {axiosInstance} from '../../utils'

const PostDetails = () => {
    const PF = "https://heroblog-api.onrender.com/images/"
    // const PF = "http://localhost:5959/images/"
    const [loading, setLoading] = useState(false);
    const [post, setPost] = useState<any>({})
    const location = useLocation();
    const path = location.pathname.split('/')[2];
    console.log(post);
    const {user} = useContext(Context);
    const [deleteErr, SetDeleteErr] = useState(false);

    const [updateMode, setUpdateMode] = useState(false); 
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [deleteSuccess, setdeleteSuccess] = useState(false);

    //render single post
    const renderSinglePost = async () => {
        setLoading(true)
        const response = await axiosInstance.get("/posts/" + path)
        setPost(response.data);
        setLoading(false)
    }

    //update post
    const savedUpdatedPost = async (e: React.SyntheticEvent<HTMLButtonElement>) => {
       await axiosInstance.put(`/posts/${post._id}`, {
        title,
        desc,
      });
      setUpdateMode(false)
      window.location.reload();
    }

    //delete post 
    const removePost = async (e: React.SyntheticEvent<HTMLButtonElement>) => {
      try {
        await axiosInstance.delete(`/posts/${post._id}`, {
          data: { author: user?.username}
        })
        setdeleteSuccess(true)
        setTimeout(() => {
          window.location.replace('/posts');
        },2000)
      }catch(err) {
        SetDeleteErr(true);
      }
    }
    
    useEffect(() => {
        renderSinglePost();
    },[path])

  return (
    <div className='controll__footer'>
      <MainNav />
        {loading ? <LoadingSpinner /> : 
        <div className='single__post__wrapper'>
          {deleteSuccess && <div className='deleteSuccess'>Post has been deleted successfully</div>}
            <div className='banner__inner'>
              <div className='banner__inner__imageWrap'>
                <img src={PF + post.photo} />
              </div>
              <div className='banner__inner__content'>
                  {updateMode ? <input type="text" defaultValue={post.title} autoFocus onChange={(e) => setTitle(e.target.value)} /> : 
                  <h1>{post.title}</h1>}
                  <p>{new Date(post.createdAt).toDateString()}</p>
              </div>
            </div>
            <div className='wrapper'>
            <Container>
              <Row>
                <Col>
                  <div className='blog__content__inner__wrapper'>
                  {user?.username === post.author && <div className='edit__wrap'> 
                        <div>
                          {deleteErr === true ? <p>You can only delete your own post</p> : ""}
                        </div>
                        <Button title={"Edit Post"}>
                          <Edit onClick={(e) => setUpdateMode(true)} />
                        </Button>
                        <Button onClick={removePost} title={"Delete Post"}>
                          <Delete />
                        </Button>
                        <Button onClick={savedUpdatedPost} title={"Save Post"}>
                          <Save />
                        </Button>
                    </div>}
                    <div className='blog__body__content'>
                      {updateMode ? <textarea defaultValue={post.desc} autoFocus rows={15} onChange={(e) => setDesc(e.target.value)} /> : 
                      <p>{post.desc}</p>}
                      <div>
                        <h4>Author: {post.author}</h4>
                      </div>
                      <p>
                        {post.categories > 1 ? "Tags:" : "Tag:"} {post.categories}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            </div>
        </div>}
        <Footer/>
    </div>
  )
}

export default PostDetails
